export const CURRENCIES = [
  { code: "USD", name: "US Dollar", symbol: "$", flag: "🇺🇸", country: "United States", color: "#2A6FE0" },
  { code: "EUR", name: "Euro", symbol: "€", flag: "🇪🇺", country: "Eurozone", color: "#1E4DB7" },
  { code: "GBP", name: "British Pound", symbol: "£", flag: "🇬🇧", country: "United Kingdom", color: "#C8102E" },
  { code: "CAD", name: "Canadian Dollar", symbol: "C$", flag: "🇨🇦", country: "Canada", color: "#D52B1E" },
  { code: "NGN", name: "Nigerian Naira", symbol: "₦", flag: "🇳🇬", country: "Nigeria", color: "#008753" },
  { code: "GHS", name: "Ghanaian Cedi", symbol: "₵", flag: "🇬🇭", country: "Ghana", color: "#FCD116" },
  { code: "KES", name: "Kenyan Shilling", symbol: "KSh", flag: "🇰🇪", country: "Kenya", color: "#BB0000" },
  { code: "RON", name: "Romanian Leu", symbol: "lei", flag: "🇷🇴", country: "Romania", color: "#002B7F" },
];

export const CURRENCY_BY_CODE = Object.fromEntries(CURRENCIES.map((c) => [c.code, c]));

export const COUNTRIES = [
  { code: "US", name: "United States", flag: "🇺🇸", currency: "USD" },
  { code: "GB", name: "United Kingdom", flag: "🇬🇧", currency: "GBP" },
  { code: "CA", name: "Canada", flag: "🇨🇦", currency: "CAD" },
  { code: "DE", name: "Germany", flag: "🇩🇪", currency: "EUR" },
  { code: "FR", name: "France", flag: "🇫🇷", currency: "EUR" },
  { code: "IT", name: "Italy", flag: "🇮🇹", currency: "EUR" },
  { code: "ES", name: "Spain", flag: "🇪🇸", currency: "EUR" },
  { code: "NL", name: "Netherlands", flag: "🇳🇱", currency: "EUR" },
  { code: "IE", name: "Ireland", flag: "🇮🇪", currency: "EUR" },
  { code: "NG", name: "Nigeria", flag: "🇳🇬", currency: "NGN" },
  { code: "GH", name: "Ghana", flag: "🇬🇭", currency: "GHS" },
  { code: "KE", name: "Kenya", flag: "🇰🇪", currency: "KES" },
  { code: "ZA", name: "South Africa", flag: "🇿🇦", currency: "USD" },
  { code: "UG", name: "Uganda", flag: "🇺🇬", currency: "USD" },
  { code: "RO", name: "Romania", flag: "🇷🇴", currency: "RON" },
];

export const SEND_METHODS = [
  { value: "bank", label: "Bank Transfer", desc: "Direct to recipient bank account", icon: "Building2" },
  { value: "mobile_money", label: "Mobile Money", desc: "M-Pesa, MTN MoMo, Airtel Money", icon: "Smartphone" },
  { value: "wallet", label: "MoneyMeet Wallet", desc: "Instant to a MoneyMeet user", icon: "Wallet" },
];
